import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const AdminRedirect: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const adminToken = localStorage.getItem('admin_token')
    if (adminToken) {
      navigate('/admin/users', { replace: true })
    } else {
      navigate('/admin/login', { replace: true })
    }
  }, [navigate])

  return null
}

export default AdminRedirect
